import {
  SERVICE_HOLDER_MOBILITY_AUTONOMOUS,
  SERVICE_HOLDER_MOBILITY_NEEDS_CANE,
  SERVICE_HOLDER_MOBILITY_NEEDS_CRUTCHES,
  SERVICE_HOLDER_MOBILITY_NEEDS_HELP,
  SERVICE_HOLDER_MOBILITY_NEEDS_SUPERVISION,
  SERVICE_HOLDER_MOBILITY_NEEDS_WALKER,
  SERVICE_HOLDER_MOBILITY_USES_WHEELCHAIR,
} from "./serviceHolder";

const mobilityOptions = [
  {
    value: SERVICE_HOLDER_MOBILITY_AUTONOMOUS,
  },
  {
    value: SERVICE_HOLDER_MOBILITY_NEEDS_CANE,
  },
  {
    value: SERVICE_HOLDER_MOBILITY_NEEDS_CRUTCHES,
  },
  {
    value: SERVICE_HOLDER_MOBILITY_NEEDS_HELP,
  },
  {
    value: SERVICE_HOLDER_MOBILITY_NEEDS_SUPERVISION,
  },
  {
    value: SERVICE_HOLDER_MOBILITY_NEEDS_WALKER,
  },
  {
    value: SERVICE_HOLDER_MOBILITY_USES_WHEELCHAIR,
  },
];

export function mobilityOptionsList() {
  return mobilityOptions;
}
